import React from 'react';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import moment from 'moment';
import ReplyIcon from '../../../Icons/ReplyIcon';

const RecursiveComment = ({ item, setComment }: any) => {
  return (
    <article
      className={tw`px-2 py-1 text-base bg-white border-t border-gray-200 `}
    >
      <footer className={tw`flex  items-center w-full`}>
        <div className={tw`flex justify-between w-full`}>
          <div className={tw`flex justify-start gap-x-2`}>
            <div
              className={tw`h-8 w-8 md:w-12 md:h-12 rounded-full bg-gray-300 items-center justify-center flex`}
            >
              <p className={tw`text-3xl text-primary`}>
                {item?.user.is_superuser
                  ? item?.user?.name?.slice(0, 1)
                  : 'Staff'.slice(0, 1)}
              </p>
            </div>
            <div className=''>
              <p
                className={tw`leading-4 items-center mr-3 text-sm text-gray-900 dark:text-white`}
              >
                {item?.user.is_superuser ? item?.user.name : 'Staff'} <br />
                <span className={tw`text-[12px]`}>{item?.branch}</span>
              </p>
            </div>
          </div>
          <p className={tw`text-sm text-gray-600 dark:text-gray-400 mt-1`}>
            {moment(item?.created).format('YYYY-MM-DD hh:mm:ss A')}
          </p>
        </div>
      </footer>
      <div className={tw`flex justify-between w-full items-center`}>
        <p className={tw`text-gray-500 text-sm ml-14 `}>{item?.comment}</p>
        <button
          type='button'
          onClick={() => setComment(item)}
          className={tw`focus:outline-none`}
        >
          <ReplyIcon />
        </button>
      </div>
      {item?.children && item?.children.length > 0 && (
        <div className={tw`ml-4 mt-1 flex `}>
          <div className={tw`border-l-2 border-gray-300 mr-4`}></div>
          <div className={tw`w-full`}>
            {item?.children?.map((child) => (
              <RecursiveComment
                key={child.id}
                item={child}
                setComment={setComment}
              />
            ))}
          </div>
        </div>
      )}
    </article>
  );
};

export default RecursiveComment;
